<template>
  <section>
    <va-breadcrumbs>
      <va-breadcrumbs-item
        label="Educação"
        to="/admin/educacao/coordenadores-all"
      />
      <va-breadcrumbs-item>
        <span style="font-style: italic; color: #0785d3">Coordenadores</span>
      </va-breadcrumbs-item>
    </va-breadcrumbs>
    <h2 class="titulo-links-escolha">Coordenadores</h2>
    <p>Listagem de todos os Coordenadores</p>

    <div class="row"  v-if="situacaoAno">
      <div class="col-md-10"></div>
      <div class="col-md-2">
        <va-button
          class="mr-2 mb-2"
          size="small"
          color="success"
          @click="registar()"
          style="float: right"
        >
          {{ $t("Registrar") }}</va-button
        >
      </div>
    </div>
    <va-input
      v-if="coordenadorALL.length > 5"
      class="flex mb-2 md6"
      placeholder="Filtrar..."
      v-model="filter"
    />
    <va-data-table
      striped="true"
      hoverable="true"
      animated="true"
      :items="coordenadorALL"
      :columns="columns"
      :per-page="perPage"
      :filter="filter"
      :current-page="currentPage"
    >
      <template #cell(escolas)="{ source: escolas }">
        <div v-for="n in escolas" :key="n"><b>{{n.nome}} </b></div>
      </template>

      <template #cell(segmentos)="{ source: segmentos }">
        <div v-if="segmentos.pre_escola == 1"><b style="color: blue;"> Pre Escola </b></div>
        <div v-if="segmentos.fundamental1 == 1"><b style="color: blue;"> Fundamental I </b></div>
        <div v-if="segmentos.fundamental2 == 1"><b style="color: blue;"> Fundamental II </b></div>
        <div v-if="segmentos.ern == 1"><b style="color: blue;"> ERN </b></div>
        <div v-if="segmentos.eja1 == 1"><b style="color: blue;"> EJA ( 2 fase até a 5 fase) </b></div>
        <div v-if="segmentos.eja2 == 1"><b style="color: blue;"> EJA ( 6 fase até a 9 fase) </b></div>
      </template>

      <template #cell(info)="{ source: info }">
        <va-button
          v-if="situacaoAno"
          class="mr-2 mb-2"
          size="small"
          @click="editarCorde(info.id_)"
        >
          {{ $t("Editar") }}
        </va-button>

        <va-button
          v-if="situacaoAno"
          class="mr-2 mb-2"
          size="small"
          color="danger"
          @click="deletar(info.id_)"
        >
          {{ $t("Deletar") }}
        </va-button>

      </template>


      <template #bodyAppend>
        <tr>
          <td colspan="8" class="table-example--pagination">
            <va-pagination v-model="currentPage" input :pages="pages" />
          </td>
        </tr>
      </template>
    </va-data-table>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import { Professor } from "@/class/professor.js";
import { Calendario } from "@/class/calendario.js";
import { Servidores } from "@/class/servidores.js";
import { DisciplinaEscolar } from "@/class/disciplina.js";
import { SegmentoEscolar } from "@/class/segmentoEscolar.js";
import { Configuracao } from "@/class/configuracao.js";
import { Escola } from "@/class/escolas.js";

import { Coordenador } from "@/class/coordenador.js";

export default defineComponent({
  data() {
    const columns = [
      { key: "nome", label: "Nome", sortable: true },
      { key: "escolas", label: "Escolas"  },
      { key: "segmentos", label: "Segmentos" },
      { key: "info", label: "Ação" },
    ];

    return {
      radioSelectedOption:"option1",
      ehFundamentalI:0,
      situacaoAno:1,
      filter: '',
      showMediumModal: false,
      showDisciplinaModal: false,
      showgerenciarHorarioModal:false,
      showgerenciarDisciplinaModal: false,
      tipo:1,
      ano:0,

      tituloModal: "",
      textoModal: "",
      info: [],
      disciplinaALL:[],
      segmentoALL:[],
      escolaALL:[],
      horariosAll:[],

      id_item:0,
      segmentoSelecionado:'',
      disciplinaSelecionada:'',
      professorSelecionado:'',
      escolaSelecionada:1,
      turnoSelecionado:'',
      professor:[],

      coordenadorALL: [],
      columns,
      perPage: 15,
      currentPage: 1,
    };
  },
  computed: {
    pages() {
      return this.perPage && this.perPage !== "0"
        ? Math.ceil(this.coordenadorALL.length / this.perPage)
        : this.coordenadorALL.length;
    },
  },
  methods: {
    registar() {
      this.$router.push({ name: "coordenadoresadd" });
    },
    async deletar(id) {
      if (window.confirm("Você realmente deseja remover esta pessoa da coordenação?")) {
        try{
          let data = await Coordenador.remover(id);
          this.$vaToast.init({
              message: "Removido com sucesso!",
              iconClass: 'fa-star-o',
              position: 'top-right',
              duration: 2500,
              fullWidth: false,
              color:'success'
          });
          this.listarTudo();
          }catch(e){
            let a = e.response.data.erro;
            this.$vaToast.init({
              message: a,
              iconClass: 'fa-star-o',
              position: 'top-right',
              duration: 2500,
              fullWidth: false,
              color:'#e42222'
            })
          }
      }
    },
    editarCorde(id){
      this.$router.push({ name: "coordenadoresedit", params: { id: id}});
    },
    async listarTudo() {
      try {
        this.coordenadorALL = [];
        let anoSelect = sessionStorage.getItem("anoSelecionado");


        let data = await Coordenador.obtemTodos(anoSelect);
        for (const el of data.data) {
          if (!el.situacao) continue;
          let novo = {
            id: el.servidor_id,
            nome: el.coordenador.nome,
            escolas: el.escola_nome,
            info: {
              id: el.servidor_id,
              id_:el.id,
              nome: el.coordenador.nome,
              funcao_id: el.login.funcao,
            },
            segmentos:{
              pre_escola: el.pre_escola,
              fundamental1: el.fundamental1,
              fundamental2: el.fundamental2,
              eja1: el.eja1,
              eja2: el.eja2,
              ern: el.ern,
            }
          };
          this.coordenadorALL.push(novo);
        }

      } catch (e) { }
    },

  },
  beforeMount() {
    this.situacaoAno = parseInt(sessionStorage.getItem("anoSitucao"));
    this.listarTudo();
  },
});
</script>

<style lang="scss" scoped>
.table-example--pagination {
  padding-top: 20px;
  text-align: center;
  text-align: -webkit-center;
}
</style>
